import { render } from "./Item7.0.vue?vue&type=template&id=68b54d86&scoped=true&ts=true"
import script from "./Item7.0.vue?vue&type=script&lang=ts"
export * from "./Item7.0.vue?vue&type=script&lang=ts"

import "./Item7.0.vue?vue&type=style&index=0&id=68b54d86&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b54d86"]])

export default __exports__